import Needs from "@/views/needs/Needs.vue";
import Ecosystems from "@/views/needs/Ecosystems.vue";

export default [
    {
        path: '/needs',
        name: 'needs',
        component: Needs,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/needs/ecosystems',
        name: 'needs.ecosystems',
        component: Ecosystems,
        meta: {
            access: ['admin'],
        }
    },
]
